import React, { useState, useEffect, useCallback } from 'react';
import { useHistory, useParams, withRouter } from 'react-router-dom';
import { DataTable } from '../../../../components/DataTable/DataTable';
import { useDataTable } from '../../../../components/DataTable/useDataTable';
import Dialog from '../../../../components/dialog/Dialog';
import { Dialog as MuiDialog, DialogContent, Button, Icon } from '@material-ui/core';
import { ClienteService } from '../../../../services/ClienteService';
import Remitente from './RemitenteNuevo';
import ACCESS from '../../../../ACCESS';

const Remitentes = ({ match, cliente: propCliente }) => {
  const history = useHistory();
  const routeParams = useParams() || {};
  const clientId = propCliente || match?.params?.id || routeParams?.id;
  const urlTabId = match?.params?.tabId || routeParams?.tabId;

  const tableState = useDataTable({ initialLimit: 15 });

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState({ show: false, title: '', options: ['Sí', 'No'], row: null });
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  // Sincronizar estado del modal cuando urlTabId cambia en la ruta
  useEffect(() => {
    if (urlTabId) {
      setSelectedId(urlTabId);
      setModalOpen(true);
    }
  }, [urlTabId]);

  const fetchData = useCallback(async () => {
    if (!clientId) return;
    setLoading(true);
    const res = await ClienteService.obtenerRemitentes(
      clientId,
      tableState.page,
      tableState.limit,
      tableState.filters,
      tableState.orderBy,
      tableState.order
    );
    setData(res.rows || []);
    setLoading(false);
  }, [clientId, tableState.page, tableState.limit, tableState.filters, tableState.orderBy, tableState.order]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const hasMore = data.length === tableState.limit;

  const columns = [
    { id: 'cliente_rems', label: 'Clave' },
    { id: 'cliente_rems_nombre', label: 'Remitente' },
    { id: 'cliente_rems_telefono', label: 'Teléfono' },
    { id: 'cliente_rems_domicilio', label: 'Domicilio' },
    { id: 'colonia', label: 'Colonia' },
    { id: 'ciudad', label: 'Ciudad' },
    { id: 'estado', label: 'Estado' },
    { id: 'cliente_rems_cp', label: 'C.P.' },
  ];

  const handleOpenCreate = () => {
    setSelectedId(null);
    setModalOpen(true);
  };

  const handleOpenEdit = (row) => {
    setSelectedId(row.id);
    setModalOpen(true);
    history.push(`/Catalogo/Cliente/${clientId}/Remitentes/${row.id}`);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedId(null);
    if (urlTabId) {
      history.push(`/Catalogo/Cliente/${clientId}/Remitentes`);
    }
  };

  const handleDeleteClick = (row) => {
    setDialog({
      show: true,
      title: `¿Borrar el remitente ${row.cliente_rems_nombre || row.cliente_rems}?`,
      options: ['Sí', 'No'],
      row,
    });
  };

  const handleDialogClose = async (op) => {
    const rowToDelete = dialog.row;
    setDialog({ show: false, title: '', options: [], row: null });

    if (op === 1 && rowToDelete) {
      setLoading(true);
      const success = await ClienteService.eliminarRemitente(rowToDelete);
      if (success) {
        fetchData();
      } else {
        setLoading(false);
      }
    }
  };

  const actions = [
    {
      id: 'edit',
      icon: 'edit',
      tooltip: 'Editar remitente',
      access: ACCESS.CATALOGO_CLIENTES_REMITENTE.EDITAR_CATALOGO,
      onClick: (actionId, row) => handleOpenEdit(row),
    },
    {
      id: 'delete',
      icon: 'delete',
      tooltip: 'Eliminar remitente',
      access: ACCESS.CATALOGO_CLIENTES_REMITENTE.ELIMINAR_CATALOGO,
      onClick: (actionId, row) => handleDeleteClick(row),
    },
  ];

  return (
    <div className="w-full">
      <DataTable
        title="Remitentes"
        headerActions={
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<Icon fontSize="small">add</Icon>}
            onClick={handleOpenCreate}
            className="!capitalize !text-xs !font-semibold !rounded-lg !py-1.5 !px-3.5"
          >
            Nuevo Remitente
          </Button>
        }
        columns={columns}
        data={data}
        loading={loading}
        actions={actions}
        hasMore={hasMore}
        page={tableState.page}
        limit={tableState.limit}
        onPageChange={tableState.handlePageChange}
        onLimitChange={tableState.handleLimitChange}
        orderBy={tableState.orderBy}
        order={tableState.order}
        onSort={tableState.handleSort}
        filters={tableState.filters}
        onFilterChange={tableState.handleFilterChange}
        onRowClick={(row) => handleOpenEdit(row)}
      />

      <Dialog dialog={dialog} onClose={handleDialogClose} />

      <MuiDialog
        open={modalOpen}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
      >
        <DialogContent className="!p-3 sm:!p-5">
          <Remitente
            cliente={clientId}
            id={selectedId}
            onSave={() => {
              handleCloseModal();
              fetchData();
            }}
            onCancel={handleCloseModal}
          />
        </DialogContent>
      </MuiDialog>
    </div>
  );
};

export default withRouter(Remitentes);
